export const organizationOrderType = {
    "CUT": "Распил",
    "CUT_PROCESSING": "Распил с обработкой",
    // "CUT_PROCESSING_ACCESSORIES": "Распил с обработкой и фурнитурой",
    "STANDARD": "Стандарт",
    "MARKET_RESIDUES": "Рыночные остатки",
}
